import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useReceiptsGridContext} from '../ReceiptsGridContext';
import {formatFloatThousandsWithCommas} from "../../../../common/utils";
import styles from './StatsPanel.module.scss';

const StatsPanel = () => {
  const {totalAmount, totalCount} = useReceiptsGridContext();
  const editedTotalAmount = Boolean(totalAmount)
    ? formatFloatThousandsWithCommas(parseFloat(`${totalAmount}`).toFixed(2))
    : '0.00';

  return (
    <div className={styles.statsContainer}>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'receipts-stats-totalCount'}
          defaultMessage={'{count} receipts'}
          values={{count: totalCount}}
        />
      </span>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'receipts-stats-totalAmount'}
          defaultMessage={'{amount} ₪'}
          values={{amount: editedTotalAmount}}
        />
      </span>
    </div>
  );
};

export default StatsPanel;
